import { lazy } from "react";
import { Navigate } from "react-router-dom";

import { GiPoliceOfficerHead } from "react-icons/gi";

const SecurityList = lazy(() => import("../components/securityList"));
const SecurityCreate = lazy(() => import("../components/securityCreate"));
const SecurityView = lazy(() => import("../components/securityView"));

const securityRoute = [

  {
    icon: GiPoliceOfficerHead,
    name: "Security",
    link: "/security",
    path: "security",
    index: 21,
    element: <SecurityList />,
    superAdminView: false,
    permission: "Security-Read",
  },
  {
    path: "security/create",
    element: <SecurityCreate />,
  },
  {
    path: "security/:id",
    element: <SecurityCreate />,
  },
  {
    path: "security/view/:id",
    element: <SecurityView />,
  },
  {
    path: "",
    element: <Navigate to="/security" replace />,
  },
  // ],
];
export default securityRoute;
